import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-small-graph-widget',
    templateUrl: './small-graph-widget.component.html',
    styleUrls: ['./small-graph-widget.component.scss'],
    standalone: false
})
export class SmallGraphWidgetComponent implements OnInit {

  @ViewChild('turnaroundGraphContainer')
  turnaroundGraphContainer: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // if (window.devicePixelRatio === 1.5) {
    //   this.graphWidth = 150;
    //   this.graphHeight = 130;
    // }
    // else {
    //   this.graphWidth = 300;
    //   this.graphHeight = 240;
    // }
  }

  @Input()
  data: any[];
  
  @Input()
  title: string;
  
  @Input()
  subTitle: string;
  
  @Input()
  primaryColour: string;

  // options
  legend: boolean = false;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = false;
  showXAxisLabel: boolean = false;
  xAxisLabel: string = '';
  yAxisLabel: string = '';
  timeline: boolean = true;
  yScaleMin: number = 10
  yScaleMax: number = 25
  // graphWidth: number = 300;
  // graphHeight: number = 240;

  colorScheme = {
    domain: ['#2878ff']
  };

  constructor() { }

  ngOnInit() {
    if (window.devicePixelRatio === 1.5) {
      // this.graphWidth = 200;
      // this.graphHeight = this.turnaroundGraphContainer.nativeElement.offsetHeight;
    }
    this.colorScheme = {
      domain: [this.primaryColour]
    }

    let ctrl = this;
    setTimeout(() => {
      if (window.devicePixelRatio === 1.5) {
        // ctrl.graphWidth = 150;
        // ctrl.graphHeight = 130;
      }
    }, 1000)
  }

}
